import { createFileRoute } from '@tanstack/react-router';

import NewProductPage from '@/components/products/new/Page';

export const Route = createFileRoute('/products/new')({
	component: NewProductPage,
});
